<template>
    <section class="about">
      <div class="container">
        <h2 data-aos="fade-right" data-aos-offset="100">
            気づいた人は始めてる<br>
            ジントニックと<br class="hidePc">スパイス料理という<br>
            最高の組み合わせ
        </h2>
        <p data-aos="fade-up" data-aos-offset="100">
            スパイス料理とジントニック。意外と知られていない美味しい組み合わせですが、その相性のよさは科学的にも証明されています。ここではボンベイ・サファイアにマッチするスパイス料理のオリジナルレシピをご紹介。ちょい足しするだけで美味しさが増す、今晩にでもすぐ試せる簡単アレンジ料理です。
        </p>
      </div>
    </section>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

.about{
    background: $gradient;
    .container{
        align-items: flex-start;
        p{
            width: 100%;
            margin-top: 54px;
            @media #{$maxM}{
                margin-top: 24px;
            }
        }
    }
}
</style>